import axios from 'axios';
import moment from 'moment';

export const getStatistics = (from_date, to_date, callback, errorcallback) => {
  const fd = moment(from_date).format('YYYY-MM-DD');
  const td = moment(to_date).format('YYYY-MM-DD');
  axios
    .get(`statistics/get_list`, { params: { from_date: fd, to_date: td } })
    .then((response) => {
      if (response.status === 200) {
        const data = response.data;
        const rows = Array.isArray(data?.rows)
          ? data.rows
          : Array.isArray(data)
            ? data
            : [];
        callback(rows);
      }
    })
    .catch((err) => {
      errorcallback(err);
    });
};
